import { MantineThemeColorsOverride } from "@mantine/core";
export const theme: MantineThemeColorsOverride = {
  colors: {
    Marigold: [
      "#ebaa32",
      "#edb449",
      "#e9a11b",
      "#d29118",
      "#ba8116",
      "#a37113",
      "#8c6110",
      "#75510e",
      "#463008",
      "#2f2005",
    ],
    Amber: [
      "#7c6354",
      "#70594c",
      "#634f43",
      "#57453b",
      "#4a3b32",
      "#3e322a",
      "#322822",
      "#251e19",
      "#191411",
      "#0c0a08",
    ],
  },
  secondaryColor: "Amber",
  primaryColor: "Marigold",
  primaryShade: 3,
};
